export const MOBILE = 360;
export const TABLET = 720;
export const DESKTOP = 1000;
